import React from "react";
import { Box } from "@mui/material";
import "./styles.css";

const Content = ({ children, style = {} }) => {
  return <Box className="content-wrapper" style={style}>{children}</Box>;
};

export default Content;
